<template>
  <div class="send-record">
    <div class="main-title">
      <p>发送请求记录</p>
    </div>
    <div class="main-body">
      <div class="list">
        <span>设备编号：</span>
        <el-input class="list-input" size="mini" v-model="primaryDeviceNo"></el-input>
        <span class="ml10">来源类型：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="sourceType">
          <el-option
            v-for="(item,key) in sourceTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10">内容：</span>
        <el-select
          class="fixed-width-100"
          size="mini"
          v-model="operateType">
          <el-option
            v-for="(item,key) in operateTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <span class="ml10">端口编号：</span>
        <el-input class="list-input-seqNo" size="mini" v-model="chargePortSeqNo"></el-input>
      </div>
      <div class="list">
        <span>时间：</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="开始日期">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          placeholder="结束日期">
        </el-date-picker>
        <div class="blue-btn ml10" @click="onQueryBtnClick">查询</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>请求编号</th>
          <th>发送时间</th>
          <th>端口编号</th>
          <th>类型</th>
          <th>内容</th>
          <th>状态</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.requestNo }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ (item.chargePortSeqNo && item.chargePortSeqNo != 'null') ? item.chargePortSeqNo + "号" : "--" }}</td>
          <td>{{ item.sourceType }}</td>
          <td>{{ item.operateType }}</td>
          <td>{{ item.status }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='6'>暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="page-count">第{{ pageIndex }}页，当前页{{ dataList.length }}条，共{{ total }}条</div>
        <div class="page-count">跳转到第
          <el-input v-model="page" class="page-choose fixed-width-35" size="mini"></el-input>
          页
        </div>
        <div class="page-count text-btn" @click="onPageChooseBtnClick">跳转</div>
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'sendRecordTotal',
  data() {
    return {
      title: '',
      pageSize: 10,
      beginIndex: 0,
      pageIndex: 1,
      page: 1,
      total: '',
      totalPage: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      startTime: '',
      endTime: '',
      chargePortSeqNo: '',
      primaryDeviceNo: '',
      operateType: '',
      operateTypeList: [
        {
          id: '',
          name: '全部'
        }, {
          id: 1,
          name: '通电'
        }, {
          id: 2,
          name: '断电'
        }, {
          id: 3,
          name: '开门'
        }, {
          id: 4,
          name: '关门'
        }, {
          id: 5,
          name: '放入电池'
        }, {
          id: 6,
          name: '取出电池'
        }, {
          id: 7,
          name: '启用'
        }, {
          id: 8,
          name: '禁用'
        },
      ],
      sourceType: '',
      sourceTypeList: [
        {
          id: '',
          name: '全部'
        }, {
          id: 2,
          name: '换电服务'
        }, {
          id: 3,
          name: '运维记录'
        }, {
          id: 4,
          name: '换电服务用户额外操作'
        }, {
          id: 5,
          name: '充电服务'
        }, {
          id: 6,
          name: '系统请求'
        }, {
          id: 7,
          name: '充电柜充电服务'
        },
      ],
      dataList: []
    }
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    this.querySendRecord();
  },
  methods: {
    querySendRecord() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo,
        chargePortSeqNo: this.chargePortSeqNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.startTime,
        endTime: this.endTime,
        operateType: this.operateType,
        sourceType: this.sourceType
      };
      this.$http.post('/managementPlatform/electricity/queryDeviceRequest', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
        self.page = Math.floor(self.beginIndex / self.pageSize) + 1;
        self.pageIndex = self.page;
        self.total = res.mdata.total;
        self.totalPage = Math.floor((parseInt(res.mdata.total) - 1) / self.pageSize) + 1;
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySendRecord();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySendRecord();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySendRecord();
    },
    onPageChooseBtnClick() {
      let index = 0;
      if (this.page <= this.totalPage && this.page > 0) {
        index = this.page;
      } else {
        index = 1;
        this.page = 1;
      }
      this.beginIndex = (index - 1) * this.pageSize;
      this.querySendRecord();
    },
    toList() {
      this.$router.push("/managePage/batterySwapMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.beginIndex);
    },
    toDetail() {
      this.$router.push("/managePage/batterySwapMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.beginIndex);
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }

  .list-input-seqNo {
    width: 100px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/sendRecordTotal.vue